import React, { useState, useRef } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Waarom de vissersmetafoor?',
  a: "Omdat het precies beschrijft wat we anders doen. De meeste bureaus bouwen een groter net (meer pagina's). Wij peilen eerst waar de vis zit (welke zoekwoorden converteren). Dat is het verschil tussen hopen en weten."
}, {
  q: 'Wat is Search Everywhere Optimization?',
  a: 'SEO is niet meer alleen Google. Je klanten zoeken ook via ChatGPT, Perplexity, Google AI Overviews en andere AI-tools. CorePrint zorgt ervoor dat je overal zichtbaar bent waar je klanten zoeken, niet alleen in de traditionele zoekresultaten.'
}, {
  q: 'Wat kost CorePrint?',
  a: 'CorePrint bestaat uit twee fases: de DataSprint (90 dagen adverteren + analyse) en de bouwfase (SEO op basis van de data). We bespreken de exacte investering in de presentatie, afgestemd op jouw markt en schaal.'
}, {
  q: 'Wat als de data tegenvalt?',
  a: 'De data valt nooit tegen, want hij vertelt altijd de waarheid. Ook als de uitkomst is dat een kanaal niet werkt voor jouw markt, is dat waardevolle informatie. Zo bespaar je jaren van inefficiënte investering.'
}, {
  q: 'Hoe weet ik of mijn markt nog vrij is?',
  a: 'Dat check je in het gratis kennismakingsgesprek. Zodra één concurrent in jouw markt start, sluit die markt. We werken altijd met één klant per markt.'
}, {
  q: 'Moet ik zelf iets doen?',
  a: 'Minimaal. Je geeft ons toegang tot je doelgroep, je doelen en je markt. Wij regelen de rest: campagne, data-analyse, rapport en bouw. Jij focust op je klanten.'
}, {
  q: 'Hoe lang duurt het voor ik resultaat zie?',
  a: 'In de eerste 4 tot 6 weken zie je al welke boodschappen aanslaan (kwalitatieve data). Na 90 dagen heb je het volledige CorePrint-rapport. Daarna bouwt organisch verkeer maand over maand.'
}];
function Item({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="border-b border-[#E8EDF8] last:border-0" data-id="element-111">
      <motion.button className="w-full text-left py-6 flex items-center justify-between gap-5" onClick={() => setOpen(!open)} whileHover={{
      x: 4
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 20
    }} data-id="element-112">
        <span className={`font-black text-[1.05rem] transition-colors duration-300 ${open ? 'text-brand-primary' : 'text-brand-dark'}`} data-id="element-113">
          {q}
        </span>
        <motion.div animate={{
        rotate: open ? 180 : 0
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 20
      }} data-id="element-114">
          <ChevronDownIcon size={22} className={open ? 'text-brand-primary' : 'text-brand-gray'} data-id="element-115" />
        </motion.div>
      </motion.button>
      <AnimatePresence data-id="element-116">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30
      }} className="overflow-hidden" data-id="element-117">
            <p className="text-brand-gray leading-relaxed text-[0.98rem] pb-6" data-id="element-118">
              {a}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-20 bg-white" data-id="element-119">
      <div className="max-w-[780px] mx-auto px-6" data-id="element-120">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        type: 'spring',
        stiffness: 100
      }} data-id="element-121">
          <div className="section-label" data-id="element-122">FAQ</div>
          <h2 className="text-[clamp(2.2rem,4vw,3.2rem)] font-black text-brand-dark leading-tight tracking-tight" data-id="element-123">
            Veelgestelde vragen
          </h2>
        </motion.div>

        <motion.div className="rounded-[2rem] border border-[#E8EDF8] divide-y divide-[#E8EDF8] bg-white overflow-hidden shadow-soft px-9" initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2,
        type: 'spring',
        stiffness: 100
      }} data-id="element-124">
          {faqs.map(f => <Item key={f.q} q={f.q} a={f.a} data-id="element-125" />)}
        </motion.div>

        <motion.div className="text-center mt-14" initial={{
        opacity: 0
      }} animate={inView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-126">
          <p className="text-brand-gray mb-6 text-[1.05rem]" data-id="element-127">
            Staat jouw vraag er niet bij?
          </p>
          <motion.a href="#gesprek" className="btn-primary" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-128">
            Stel je vraag in een presentatie
          </motion.a>
        </motion.div>
      </div>
    </section>;
}